import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Section, Container } from 'components/shared';
import TitleCTA from '../TitleCTA';
import styled from 'styled-components';
import cx from 'classnames';
import { isValidTitle } from 'utils/validateTitle';

const Heading = styled.h2`
  font-size: 2.15rem;
`;

const filterItems = (resources) =>
  resources.filter((resource) => resource.pdfFile.href && resource.ctaText);

const WideTextBanner = ({ rendering, fields }) => {
  const title = getFieldValue(fields, 'title');
  const downloadableResources =
    getFieldValue(fields, 'downloadableResources') || [];
  const textStyle = getFieldValue(fields, 'textStyle') || 'blue-white';
  const { componentName } = rendering;

  const filteredItems = filterItems(downloadableResources);

  if (filteredItems.length === 0) {
    return null;
  }

  return (
    <Section id={'file'} tabIndex={'-1'}>
      <Container>
        {isValidTitle(title) && (
          <Heading
            className={cx(
              'font-bold font-trade-gothic-20 text-center',
              'mb-5 md:mb-4 leading-tight',
              {
                'text-mattamy-blue': textStyle !== 'white-blue',
                'text-white': textStyle === 'white-blue',
              },
            )}
          >
            {title}
          </Heading>
        )}
      </Container>
      {filteredItems.map((item) => (
        <TitleCTA
          key={item.pdfFile.key}
          pdfFile={item.pdfFile}
          text={item.text}
          componentName={componentName}
          ctaText={item.ctaText}
          download={true}
          textStyleDownload={item.textStyle}
        />
      ))}
    </Section>
  );
};

export default WideTextBanner;
